<div class="invoice-detail">
	<p-confirmDialog
		appendTo="body"
		key="resetInvoice"
		[style]="{ width: '35vw' }"></p-confirmDialog>

	@if ((invoice.errors?.length || invoice.warnings?.length) && invoice.primaryPdf) {
		<app-ocr-suggestions
			[currentValues]="ocrCurrentValues"
			[fetchFn]="fetchOcrSuggestions"
			[canSubmit]="invoice.canSubmit"
			[submitFn]="doOcrSubmit"
			buttonText="Update and Submit Invoice"></app-ocr-suggestions>
	}

	@if (invoiceJournals().length) {
		<div class="oi-history">
			<div
				class="oi-history__header"
				(click)="oiHistoryExpanded = !oiHistoryExpanded">
				<i class="pi pi-history"></i>
				<span>Open Invoice History</span>
				<i
					class="pi oi-history__chevron"
					[class.pi-chevron-down]="oiHistoryExpanded"
					[class.pi-chevron-up]="!oiHistoryExpanded"></i>
			</div>
			@if (oiHistoryExpanded) {
				<p-timeline
					[value]="sortedJournals()"
					class="oi-history__timeline">
					<ng-template
						pTemplate="opposite"
						let-journal>
						@if (journal.user !== "Buyer") {
							<ng-container
								[ngTemplateOutlet]="journalRow"
								[ngTemplateOutletContext]="{ $implicit: journal }"/>
						}
					</ng-template>
					<ng-template
						pTemplate="content"
						let-journal>
						@if (journal.user === "Buyer") {
							<ng-container
								[ngTemplateOutlet]="journalRow"
								[ngTemplateOutletContext]="{ $implicit: journal }"/>
						}
					</ng-template>
				</p-timeline>
				<ng-template
					#journalRow
					let-journal>
					<div class="oi-history-row">
						<div class="oi-history-row__header">
							<p-tag
								[value]="journal.action"
								severity="secondary"
								class="oi-history-row__tag"/>
							<span class="oi-history-row__date">
                                {{ journal.actionDate | date: "MMM d, y, h:mm a" }}
                            </span>
						</div>
						<div class="oi-history-row__user">{{ journal.user }}</div>
						@if (journal.comments) {
							<div class="oi-history-row__comments">{{ journal.comments }}</div>
						}
					</div>
				</ng-template>
			}
		</div>
	}

	@if (ticketJournals().length) {
		<div class="oi-history">
			<div
				class="oi-history__header"
				(click)="otHistoryExpanded = !otHistoryExpanded">
				<i class="pi pi-history"></i>
				<span>Open Ticket History</span>
				<i
					class="pi oi-history__chevron"
					[class.pi-chevron-down]="otHistoryExpanded"
					[class.pi-chevron-up]="!otHistoryExpanded"></i>
			</div>
			@if (otHistoryExpanded) {
				<p-timeline
					[value]="sortedTicketJournals()"
					class="oi-history__timeline">
					<ng-template
						pTemplate="opposite"
						let-journal>
						@if (journal.actionByRootOrgName === "RK Supply") {
							<ng-container
								[ngTemplateOutlet]="journalRow"
								[ngTemplateOutletContext]="{ $implicit: journal }"/>
						}
					</ng-template>
					<ng-template
						pTemplate="content"
						let-journal>
						@if (journal.actionByRootOrgName !== "RK Supply") {
							<ng-container
								[ngTemplateOutlet]="journalRow"
								[ngTemplateOutletContext]="{ $implicit: journal }"/>
						}
					</ng-template>
				</p-timeline>
				<ng-template
					#journalRow
					let-journal>
					<div class="oi-history-row">
						<div class="oi-history-row__header">
							<p-tag
								[value]="journal.action"
								severity="secondary"
								class="oi-history-row__tag"/>
							<span class="oi-history-row__date">
                                {{ journal.actionDatetime | date: "MMM d, y, h:mm a" }}
                            </span>
						</div>
						<div class="oi-history-row__user">{{ journal.actionByUserFullName }}</div>
						@if (journal.action !== "COMMENT") {
							<div class="oi-history-row__comments">{{ journal.status }}</div>
						} @else {
							<div class="oi-history-row__comments">{{ journal.comments }}</div>
						}
					</div>
				</ng-template>
			}
		</div>
	}

	@if (invoice.submissionErrors?.length || invoice.submissionWarnings?.length) {
		<div class="oi-history">
			<div
				class="oi-history__header submission-header"
				(click)="submissionHistoryExpanded = !submissionHistoryExpanded">
				<i
					class="pi pi-exclamation-circle"
					style="color: #dc3545"></i>
				<span>Submission Issues</span>
				<i
					class="pi oi-history__chevron"
					[class.pi-chevron-down]="submissionHistoryExpanded"
					[class.pi-chevron-up]="!submissionHistoryExpanded"></i>
			</div>
			@if (submissionHistoryExpanded) {
				<div class="submission-issues">
					@if (invoice.submissionErrors?.length) {
						<div class="invoice-banner invoice-banner--error">
							<i class="pi pi-times-circle"></i>
							{{ invoice.submissionErrors!.map((e) => e.message).join("; ") }}
						</div>
					}

					@if (invoice.submissionWarnings?.length) {
						<div class="invoice-banner invoice-banner--warning">
							<i class="pi pi-exclamation-triangle"></i>
							{{ invoice.submissionWarnings!.map((e) => e.message).join("; ") }}
						</div>
					}
				</div>
			}
		</div>
	}

	@if (invoice.ticketComplianceStatus === "errors") {
		<div class="oi-history">
			<div
				class="oi-history__header compliance-header"
				(click)="ticketComplianceExpanded = !ticketComplianceExpanded">
				<i class="pi pi-exclamation-circle"></i>
				<span>Ticket Compliance</span>
				<i
					class="pi oi-history__chevron"
					[class.pi-chevron-down]="ticketComplianceExpanded"
					[class.pi-chevron-up]="!ticketComplianceExpanded"></i>
			</div>
			@if (ticketComplianceExpanded) {
				<div class="submission-issues">
					<div class="invoice-banner invoice-banner--warning">
						<i class="pi pi-exclamation-triangle"></i>
						{{ invoice.ticketComplianceErrors!.map((e) => e.message).join("; ") }}
					</div>
				</div>
			}
		</div>
	}

	@if (invoice.warnings?.length || invoice.errors?.length) {
		<div class="oi-history">
			<div class="oi-history__header submission-header">
				<i
					class="pi pi-exclamation-circle"
					style="color: #dc3545"></i>
				<span>Validation Issues</span>
			</div>
			<div class="submission-issues">
				@if (invoice.errors?.length) {
					<div class="invoice-banner invoice-banner--error">
						<i class="pi pi-times-circle"></i>
						{{ invoice.errors!.map((e) => e.message).join("; ") }}
					</div>
				}

				@if (invoice.warnings?.length) {
					<div class="invoice-banner invoice-banner--warning">
						<i class="pi pi-exclamation-triangle"></i>
						{{ invoice.warnings!.map((e) => e.message).join("; ") }}
					</div>
				}
			</div>
		</div>
	}

	<div class="project-controller">
		<div class="spacing-bottom">
			<span class="font-bold">Requisitioner:</span>
			{{ invoice.requisitioner }}
			<div>
				<span class="font-bold">Enverus Requisitioner</span>
				@if (hasRequisitionerError || invoice.canSubmit) {
					<p-select
						[(ngModel)]="invoice.enverusRequisitioner"
						[options]="requisitionerStore.requisitioners()[invoice.parentCompany]"
						optionLabel="formattedName"
						optionValue="formattedName"
						[filter]="true"
						filterPlaceholder="Search requisitioners"
						placeholder="Select requisitioner"
						class="requisitioner-select"></p-select>
				} @else {
					{{ invoice.enverusRequisitioner }}
				}
			</div>
		</div>
		<div class="spacing-bottom">
			<span class="font-bold">Client:</span>
			{{ invoice.name }}
		</div>

		<div>
			<a
				[href]="invoiceUrl"
				class="no-underline"
				target="_blank">
				<i class="pi pi-link"></i>
				Invoice Record
			</a>
		</div>
		<div>
			<a
				[href]="salesOrderUrl"
				class="no-underline"
				target="_blank">
				<i class="pi pi-link"></i>
				Sales Order Record
			</a>
		</div>
		@if (invoice.openInvoiceUrl) {
			<div>
				<a
					[href]="invoice.openInvoiceUrl"
					class="no-underline"
					target="_blank">
					<i class="pi pi-link"></i>
					Open Invoice
				</a>
			</div>
		}
		@if (invoice.openTicketUrl) {
			<div>
				<a
					[href]="invoice.openTicketUrl"
					class="no-underline"
					target="_blank">
					<i class="pi pi-link"></i>
					Open Ticket
				</a>
			</div>
		}
	</div>
	<div class="invoice-meta">
		@if (invoice.po) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">PO #</span>
				<span class="meta-value">{{ invoice.po }}</span>
			</p-chip>
		}
		@if (invoice.ticketNumber) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">SO #</span>
				<span class="meta-value">{{ invoice.ticketNumber }}</span>
			</p-chip>
		}
		@if (invoice.jobLocation) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">Job Location</span>
				<span class="meta-value">{{ invoice.jobLocation }}</span>
			</p-chip>
		}
		@if (invoice.afe) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">AFE</span>
				<span class="meta-value">{{ invoice.afe }}</span>
			</p-chip>
		}
		@if (invoice.area) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">Area</span>
				<span class="meta-value">{{ invoice.area }}</span>
			</p-chip>
		}
		@if (invoice.cc) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">CC</span>
				<span class="meta-value">{{ invoice.cc }}</span>
			</p-chip>
		}
		@if (invoice.category) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">Category</span>
				<span class="meta-value">{{ invoice.category }}</span>
			</p-chip>
		}
		@if (invoice.woNumber) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">WO #</span>
				<span class="meta-value">{{ invoice.woNumber }}</span>
			</p-chip>
		}
		@if (invoice.costCenter) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">Cost Center</span>
				<span class="meta-value">{{ invoice.costCenter }}</span>
			</p-chip>
		}
		@if (invoice.glCode) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">GL Code</span>
				<span class="meta-value">{{ invoice.glCode }}</span>
			</p-chip>
		}
		@if (invoice.sapDescription) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">SAP Description</span>
				<span class="meta-value">{{ invoice.sapDescription }}</span>
			</p-chip>
		}
		@if (invoice.majorMinor) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">Major Minor</span>
				<span class="meta-value">{{ invoice.majorMinor }}</span>
			</p-chip>
		}
		@if (invoice.otDisplayStatus) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">OT Status</span>
				<span class="meta-value">{{ invoice.otDisplayStatus }}</span>
			</p-chip>
		}
		@if (invoice.oiDisplayStatus) {
			<p-chip class="invoice-meta-chip">
				<span class="meta-label">OI Status</span>
				<span class="meta-value">{{ invoice.oiDisplayStatus }}</span>
			</p-chip>
		}

	</div>
	@if (!loading) {
		<div class="table-container">
			<p-table
				[tableStyle]="{ 'min-width': '15rem', 'font-size': '14px' }"
				[value]="invoiceDetails()"
				class="custom-invoice-table">
				<ng-template
					pTemplate="header"
					class="line-item-header">
					<tr>
						<th>Item Number</th>
						<th>Item Name</th>
						<th>Billing Class</th>
						<th>Rate</th>
						<th>Quantity</th>
						<th>Amount</th>
					</tr>
				</ng-template>
				<ng-template
					let-item
					pTemplate="body">
					<tr>
						<td>{{ item.line }}</td>
						<td>{{ item.item }}</td>
						<td>{{ item.class }}</td>
						<td>{{ item.rate }}</td>
						<td>{{ item.quantity }}</td>
						<td>{{ item.amount | currency }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	} @else {
		<div class="spinner-container invoice-summary">
			<app-embark-spinner
				[size]="'3'"
				[strokeWidth]="'6'"></app-embark-spinner>
		</div>
	}
	<!-- Container for dates and totals -->
	<div class="invoice-summary">
		<div class="invoice-dates">
			<p>Ship Date: {{ invoice.shipDate }}</p>
			<p>Start Date: {{ invoice.date }}</p>
			<p>End Date: {{ invoice.date }}</p>
		</div>
		<div class="totals-table">
			<table>
				<tbody>
					@if (!loading) {
						<tr>
							<td>Subtotal</td>
							<td>{{ subtotal | currency }}</td>
						</tr>
					}
				<tr>
					<td>Tax</td>
					<td>{{ invoice.tax | currency }}</td>
				</tr>
					@if (invoice.discount && invoice.discount > 0) {
						<tr>
							<td>Discount</td>
							<td>{{ invoice.discount }}</td>
						</tr>
					}
				<tr class="total-row">
					<td>Total</td>
					<td class="total-amount">{{ invoice.amount | currency }}</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="button-container">
		@if (invoice.ticketNumber && !environment.production) {
			<p-button
				(onClick)="logFromTicketPayload()"
				[outlined]="true"
				severity="secondary"
				label="Log FromTicket Payload"></p-button>
		}

		@if (invoice.otStatus || invoice.oiStatus) {
			@if (invoice.isSubmitting) {
				<app-embark-spinner
					[size]="'3'"
					[strokeWidth]="'6'"></app-embark-spinner>
			} @else {
				<p-button
					(onClick)="confirmReset(invoice)"
					[outlined]="true"
					severity="danger"
					label="Reset"></p-button>
			}
		}

		@if (files.length > 0) {
			<p-button
				(onClick)="viewPdf()"
				[outlined]="true"
				label="View PDF"></p-button>
		}

		@if (onSubmit && invoice.canSubmit) {
			@if (invoice.isSubmitting) {
				<app-embark-spinner
					[size]="'3'"
					[strokeWidth]="'6'"></app-embark-spinner>
			} @else {
				<p-button
					(onClick)="onSubmit(invoice)"
					[disabled]="!requisitionerErrorResolved"
					label="Submit Invoice"></p-button>
			}
		}

		@if (canTicketFlip()) {
			<p-button
				(onClick)="manualTicketFlip()"
				label="Flip Ticket"></p-button>
		}
	</div>
</div>
